const NodeModes = {
  PLAIN: 'plain',
  CHART: 'chart',
};

const InputModes = {
  NUMERIC: 'numeric',
  DROPDOWN: 'dropdown',
  SLIDER: 'slider',
};

const InputDefaultOption = "Don't know";
const SoftEvidenceInputOption = {
  label: 'Soft Evidence',
  value: '~Soft Evidence~',
};

const DefaultGraphics = {
  input: {},
  graph: {
    width: 200,
    height: 100,
  },
  chart: {
    decimalPlaces: 2,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
  },
};

const FlatModelGraphKey = '___flat____model___';
const ModelViewGraphKey = '___model___view____';
const FlatViewThreshold = 300;

const ComponentDefaults = {
  ComponentHeight: '82vh',
  ComponentHeightMultipler: 0.82,
  LeftWidth: '12vw',
  LeftWidthMultiplier: 0.12,
  LeftWidthMin: 130,
  RightWidth: '14vw',
  RightWidthMultiplier: 0.14,
  RightWidthMin: 230,
  MiddleWidth: '74vw',
  MiddleWidthMultiplier: 0.74,
  MinimisedWidth: 25,
};

const ComponentKeys = {
  ModellerDataEntryPopupKey: 'ModellerDataEntryPopupKey',
  ModellerModelPropertiesPopupKey: 'ModellerModelPropertiesPopupKey',
  ModellerResultsDialogKey: 'ModellerResultsDialogKey',
  ModellerAddCaseDialog: 'ModellerAddCaseDialog',
  ModellerNodeVariablesViewKey: 'ModellerNodeVariablesViewKey',
  ModellerNodeProbabilityTableViewKey: 'ModellerNodeProbabilityTableViewKey',
};

const OperationMode = {
  ModellerPortal: 'ModellerPortal',
  ModellerStandalone: 'ModellerStandalone',
  ModellerWebApp: 'ModellerWebApp',
};

const GraphDefaults = {
  ChartModeExtraHeight: 20,
};

export default {
  NodeModes,
  InputModes,
  InputDefaultOption,
  DefaultGraphics,
  FlatModelGraphKey,
  ModelViewGraphKey,
  FlatViewThreshold,
  ComponentDefaults,
  ComponentKeys,
  OperationMode,
  GraphDefaults,
  SoftEvidenceInputOption,
};
